import React, { useEffect, useState } from "react";
import '../../assets/css/style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import HeaderCourse from "./header-course";
import HeaderEmployee from "./header-employee";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useUser } from "../UserContext";
import HeaderResident from "./header-resident";
import HeaderFilterResident from "./header-filter-resident";

window.globalFilter = window.globalFilter || { value: "0" };
const Header = () => {
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const [isCollapsed, setIsCollapsed] = useState(false);
    const user = useUser();
    const location = useLocation();
    const [showInputBox, setShowInputBox] = useState(false);

    const DisplayHeaderEmployee = location.pathname === "/dashboard" || location.pathname.includes("employee") || location.pathname.includes("ahca-regulations") || location.pathname.includes("task-type") || location.pathname.includes("training-event");
    const DisplayHeaderResident = location.pathname === "/admission-log" || location.pathname.includes("resident");

    const [searchFilter, setSearchFilter] = useState("0");
    const [searchTerm, setSearchTerm] = useState(""); // Added search term state
    const [showHeaders, setShowHeaders] = useState(false);
    const [userMenuOpen, setUserMenuOpen] = useState(false);


    const toggleHeaders = () => {
        setShowHeaders(!showHeaders);
    };

    const isAdminImpersonating = localStorage.getItem("original_admin_token") !== null;

    const handleSwitchBackToAdmin = () => {
        const originalToken = localStorage.getItem("original_admin_token");
        if (originalToken) {
            localStorage.clear();
            localStorage.setItem("token", originalToken);
            localStorage.setItem("auth_token", originalToken);
            window.location.href = "/home";
        }
    };

    useEffect(() => {
        if (!token) {
            setError("No token found, redirecting to login...");
            navigate("/login");
            return;
        }

        const root = document.getElementById('root');
        if (root) {
            if (isCollapsed) {
                root.classList.add('nav-collapsed-min');
            } else {
                root.classList.remove('nav-collapsed-min');
            }
        }
    }, [token, navigate, isCollapsed]);

    const toggleSidebar = (e) => {
        e.preventDefault();
        setIsCollapsed((prev) => !prev);
    };

    const handleFilterChange = (newValue) => {
        setSearchFilter(newValue);
        window.globalFilter.value = newValue;
        // Dispatch an event to notify other components
        window.dispatchEvent(new CustomEvent('filterChanged', { detail: newValue }));
    };

    const showInput = () => {
        setShowInputBox(true);
    }


    const renderHeader = () => (
        <div className="App">
            <section id="header" className="header-content-container animate-fade-up">
                <div className="header-section relative">
                    <div className="col-4 d-flex flex-lg-row align-items-center">
                        <div className="menu-button">
                            <a href="#/" onClick={toggleSidebar} className="toggle-min" id="step4">
                                <i className="fa fa-bars"></i>
                            </a>
                        </div>
                        <div className="">
                            <a href="/dashboard" className="logout-text">
                                <span className="newlogo-facilitname" data-tooltip={user?.user?.facility?.name || "Facility Name"}>
                                    {user?.user?.facility?.name || "Facility Name"}
                                    {/* Wesley Home Estate Assisted Living Facility */}
                                </span>
                            </a>
                        </div>
                    </div>
                    <div className="col-8 pr-5">
                        <div className="flex justify-between items-center">
                            <ul className="nav-left">
                                {DisplayHeaderResident && (
                                    <li className="searchDropdown">
                                        <HeaderFilterResident
                                            searchFilter={searchFilter}
                                            setSearchFilter={handleFilterChange}
                                            searchTerm={searchTerm}
                                            setSearchTerm={setSearchTerm}
                                            isResidentDashboard={false}
                                        />
                                    </li>
                                )}
                                {DisplayHeaderEmployee && (
                                    <li className="searchDropdown">
                                        <HeaderEmployee />
                                    </li>
                                )}

                                {DisplayHeaderEmployee && (
                                    <li className="searchDropdown">
                                        <HeaderCourse />
                                    </li>
                                )}

                                {DisplayHeaderResident && (
                                    <li className="searchDropdown">
                                        <HeaderResident />
                                    </li>
                                )}
                                {showHeaders && (
                                    <li className="showFilterResidence">
                                        {DisplayHeaderResident && (
                                            <HeaderFilterResident
                                                searchFilter={searchFilter}
                                                setSearchFilter={handleFilterChange}
                                                searchTerm={searchTerm}
                                                setSearchTerm={setSearchTerm}
                                                isResidentDashboard={false}
                                            />
                                        )}
                                    </li>
                                )}
                                {/* {showHeaders && (
                                <li className="showFilterResidence">
                                    {DisplayHeaderResident && <HeaderFilterResident />}
                                </li>
                            )} */}
                                {DisplayHeaderResident && (
                                    <li>
                                        <a href="#" className="faq" onClick={toggleHeaders}>
                                            <strong>
                                                <i className="fa-solid fa-filter"></i>
                                            </strong>
                                        </a>
                                    </li>
                                )}
                                {/* 
                                <li>
                                    <a
                                        href="https://alfboss.com/faq/"
                                        className="faq"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <strong>?</strong>
                                    </a>
                                </li> */}
                                {/* <li className="text-normal">
                                <span className="header-name">
                                    {user.user?.user?.first_name || " "}
                                </span>
                            </li>
                            <li className="logout-button">
                                <a href="/logout" className="logout-text" onClick={() => console.log("Logout triggered")}>
                                    Logout
                                </a>
                            </li> */}
                            </ul>
                            <div className="flex justify-center items-center gap-3">
                                <a
                                    href="https://alfboss.com/faq/"
                                    className="faq"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <strong><i className="fa-solid fa-circle-question hover:text-white"></i></strong>
                                </a>
                                <div className="relative">
                                    <button
                                        onClick={() => setUserMenuOpen(!userMenuOpen)}
                                        className="flex items-center space-x-3 px-4 py-4 rounded-lg hover:bg-white/30 hover:backdrop-blur-sm transition"
                                    >
                                        <div className="w-10 h-10 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-full flex items-center justify-center">
                                            <span className="text-white text-xl font-semibold">{(user?.user?.user?.first_name ? user?.user?.user?.first_name : user?.user?.user?.username || " ")?.charAt(0)?.toUpperCase()}</span>
                                        </div>
                                        <div className="md:block  text-left">
                                            <div className="text-3xl text-white font-medium text-slate-900">    {user?.user?.user?.first_name || " "}</div>
                                            {/* <div className="text-xs text-slate-500">Administrator</div> */}
                                        </div>
                                        <i className="fas fa-chevron-down"></i>
                                    </button>

                                    {userMenuOpen && (
                                        <div className="absolute right-0 mt-2 w-max min-w-[14rem] bg-white rounded-lg shadow-lg border border-slate-200 py-1 z-50">
                                            {isAdminImpersonating && (
                                                <>
                                                    <button 
                                                        onClick={handleSwitchBackToAdmin}
                                                        className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-emerald-600 hover:bg-emerald-50 no-underline hover:!no-underline"
                                                    >
                                                        <p className="text-2xl m-0 !no-underline hover:!no-underline whitespace-nowrap">  <i className="fas fa-user-shield"></i>
                                                            <span className="ml-2 !no-underline hover:!no-underline">Switch back to Admin</span>
                                                        </p>
                                                    </button>
                                                    <hr className="my-1" />
                                                </>
                                            )}
                                            
                                            <Link to={"/logout"} className="hover:!no-underline">
                                                <button className="w-full flex items-center space-x-3 px-4 py-2 text-sm text-red-600 hover:bg-red-50 no-underline hover:!no-underline">
                                                    <p className="text-2xl m-0 !no-underline hover:!no-underline">  <i className="fas fa-sign-out-alt"></i>
                                                        <span className="ml-2 !no-underline hover:!no-underline">Logout</span>
                                                    </p>
                                                </button>
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </section>
        </div >
    );

    if (error) {
        return renderHeader();
    }

    return renderHeader();
};

export default Header;
